document.addEventListener('DOMContentLoaded', function () {
  if (document.documentElement.dataset.svHomeReady === 'true') return;
  document.documentElement.dataset.svHomeReady = 'true';
  document.querySelectorAll('.sv-home [data-add-to-cart]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      var form = button.closest('form');
      if (!form) return;
      event.preventDefault();
      var data = new FormData(form);
      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('add');
        window.location.assign('/cart');
      }).catch(function () {
        button.disabled = false;
        form.submit();
      });
    });
  });
document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;
    const cards = [...track.children];
    const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const setActive = () => {
      if (!cards.length) return;
      const mid = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach((card, index) => {
        const center = card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(center - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });
      cards.forEach((card, index) => card.classList.toggle('is-active', index === best));
      dots.forEach((dot, index) => {
        const on = index === best;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    let frame = 0;
    let generation = 0;
    const closest = () => {
      const mid = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach((card, index) => {
        const center = card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(center - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });
      return best;
    };
    const centerOf = (index) => {
      const card = cards[index];
      if (!card) return track.scrollLeft;
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      return Math.min(max, Math.max(0, left));
    };
    const animateTo = (left) => {
      const run = ++generation;
      cancelAnimationFrame(frame);
      if (motion === 'auto') {
        track.style.scrollSnapType = '';
        track.scrollTo({ left, behavior: 'auto' });
        return;
      }
      const start = track.scrollLeft;
      const change = left - start;
      if (Math.abs(change) < 1) {
        track.style.scrollSnapType = '';
        return;
      }
      track.style.scrollSnapType = 'none';
      const t0 = performance.now();
      const tick = (now) => {
        if (run !== generation) return;
        const progress = Math.min(1, (now - t0) / 420);
        const eased = 1 - (1 - progress) ** 3;
        track.scrollLeft = start + change * eased;
        if (progress < 1) frame = requestAnimationFrame(tick);
        else track.style.scrollSnapType = '';
      };
      frame = requestAnimationFrame(tick);
    };
    const markPressed = (button) => {
      [prev, next].forEach((item) => {
        if (!item) return;
        const on = item === button;
        item.classList.toggle('is-pressed', on);
        item.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    prev?.addEventListener('click', () => {
      markPressed(prev);
      animateTo(centerOf(Math.max(0, closest() - 1)));
    });
    next?.addEventListener('click', () => {
      markPressed(next);
      animateTo(centerOf(Math.min(cards.length - 1, closest() + 1)));
    });
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (!cards[index]) return;
        animateTo(centerOf(index));
      });
    });
    const recenter = (index) => {
      const target = centerOf(index);
      if (Math.abs(track.scrollLeft - target) < 1) {
        setActive();
        return;
      }
      track.style.scrollSnapType = 'none';
      track.scrollLeft = target;
      track.style.scrollSnapType = '';
      setActive();
    };
    track.addEventListener('scroll', setActive, { passive: true });
    const startIndex = Math.max(0, cards.findIndex((card) => card.classList.contains('is-active')));
    if (window.ResizeObserver) {
      new ResizeObserver(() => {
        const current = cards.findIndex((card) => card.classList.contains('is-active'));
        recenter(current < 0 ? closest() : current);
      }).observe(track);
    }
    recenter(startIndex);
  });

  document.querySelectorAll('[data-category-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-category-track]');
    const prev = carousel.querySelector('[data-category-prev]');
    const next = carousel.querySelector('[data-category-next]');
    if (!track || !prev || !next) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const step = () => {
      const card = track.querySelector('.category-card');
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    const place = () => {
      const frame = track.querySelector('.category-card__frame');
      if (!frame) return;
      const top = Math.max(0, (frame.getBoundingClientRect().height - prev.offsetHeight) / 2);
      prev.style.top = top + 'px';
      next.style.top = top + 'px';
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    prev.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' });
    });
    next.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(() => { place(); update(); }).observe(track);
    place();
    update();
  });
});
